import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttopunertigacab() {



const cardData = {
  keyword: " Mumbai Airport to Pune Ertiga on Rent",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai Airport to Pune Ertiga cab services, offering a spacious and convenient travel option for families, small groups, and business travelers. Our well-maintained Maruti Suzuki Ertiga vehicles provide comfortable seating, ample luggage space, and smooth performance for long-distance journeys. The trip from Mumbai Airport to Pune covers around 150 km via the Mumbai–Pune Expressway and typically takes about 3 to 3.5 hours depending on traffic conditions. Velocity Cab offers flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. With professional drivers, punctual airport pickups, easy online booking, and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai Airport to Pune Ertiga cab travel.",

topPlaces: [
  {
    title: "Bund Garden",
    description: "Bund Garden is a scenic riverside park offering lush greenery, boating opportunities, and peaceful walking paths. It is a perfect place for families, couples, and nature lovers seeking relaxation."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is one of Pune's oldest landmarks, offering panoramic city views from its historic temple complex. Travelers can climb the stone steps, visit ancient shrines, and enjoy breathtaking scenery."
  },
   {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a beautifully landscaped Japanese-style garden featuring serene ponds, lush greenery, and elegant walking paths. Travelers booking a sedan cab in Pune can enjoy peaceful strolls, scenic photography, and a relaxing escape from the city's busy streets."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular recreational garden in Pune featuring beautifully maintained lawns and the famous Siddhivinayak Temple. Visitors can relax amidst nature, enjoy leisurely walks, and experience one of the city's favorite family-friendly destinations."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum is home to thousands of rare artifacts, traditional musical instruments, sculptures, and decorative objects representing India's rich cultural heritage. It offers an enriching experience for history and art enthusiasts."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a magnificent heritage monument associated with India's freedom movement. Visitors can explore its elegant architecture, peaceful gardens, and museum dedicated to Mahatma Gandhi while learning about Pune's historical significance."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut Shiva temple carved from a single basalt rock. Its tranquil surroundings and remarkable architecture make it a popular destination for spirituality, history, and photography."
  },
 
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is Pune's iconic historical fort and a symbol of the Maratha Empire. Visitors can explore its grand gateways, historic ruins, and captivating light and sound show that showcases the city's rich heritage."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a premier shopping and entertainment destination featuring international brands, restaurants, cinemas, and family-friendly attractions, making it ideal for a day of leisure."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a scenic getaway on the outskirts of Pune, popular for its peaceful waterfront views, beautiful sunsets, and relaxing atmosphere. It is an excellent destination for picnics and photography."
  }
],



services: [
{
name: "Mumbai Airport to Pune Ertiga on Rent",
description: "Mumbai Airport to Pune Ertiga on rent service offers spacious and comfortable SUV travel for families and small groups arriving at the airport. The Maruti Ertiga is a popular 6–7 seater vehicle known for its comfortable seating, smooth ride quality, and excellent mileage for long-distance travel. Professional drivers provide punctual pickup from Mumbai Airport terminals, including Terminal 1 and Terminal 2, with assistance for luggage handling. The journey via the Mumbai–Pune Expressway ensures fast and safe travel to Pune. This service is ideal for airport transfers, corporate travel, and family trips. Travelers benefit from air-conditioned vehicles, ample luggage space, and transparent pricing with easy online booking options."
},
{
name: "Mumbai to Pune Ertiga Cab",
description: "Mumbai to Pune Ertiga cab service provides reliable intercity transportation using spacious 7-seater vehicles suitable for families and group travel. The Ertiga ensures comfortable seating, smooth highway performance, and economical pricing compared to premium SUVs. Professional drivers provide timely pickups from Mumbai locations including airport, railway stations, and residential areas. This service is widely used for airport transfers, business travel, and weekend trips to Pune. Air-conditioned interiors and well-maintained vehicles ensure a comfortable long-distance journey with safe expressway travel."
},
{
name: "Navi Mumbai to Pune Ertiga Cab",
description: "Navi Mumbai to Pune Ertiga cab service offers convenient transportation between Navi Mumbai and Pune city. Travelers can enjoy comfortable rides in spacious Ertiga vehicles with professional drivers ensuring safe and smooth expressway travel. This service is ideal for corporate travelers, families, and tourists traveling between the two cities. Pickup is available from areas such as Vashi, Nerul, Belapur, and Kharghar."
},
{
name: "Dadar to Pune Ertiga Cab Booking",
description: "Dadar to Pune Ertiga cab booking provides easy and reliable transportation between Dadar in Mumbai and Pune. Travelers can book spacious Ertiga vehicles for comfortable long-distance travel. Professional drivers ensure timely pickups from Dadar East and West, railway stations, and nearby areas. This service is ideal for business trips, family travel, and airport connections."
},
{
name: "One Way Ertiga Cab Booking",
description: "One way Ertiga cab booking offers economical travel for passengers needing a single-direction trip between Mumbai and Pune. Travelers only pay for one-way travel, making it a cost-effective option. Spacious Ertiga vehicles ensure comfortable seating and smooth highway performance. Professional drivers provide safe driving and punctual pickups."
},
{
name: "7 Seater Car Rental Mumbai Airport",
description: "7 seater car rental at Mumbai Airport provides convenient travel for families and small groups. Vehicles such as Ertiga offer spacious seating, luggage space, and comfortable travel for long-distance journeys. Professional drivers provide airport pickup and safe expressway travel to Pune and nearby destinations."
},
{
name: "6 Seater Car Rental Mumbai Airport",
description: "6 seater car rental at Mumbai Airport offers comfortable transportation for small groups traveling together. Vehicles are well-maintained with air-conditioning and spacious interiors. This service is ideal for airport transfers and outstation trips to Pune with professional drivers ensuring safe travel."
},
{
name: "Pune to Mumbai Airport Drop Taxi Service",
description: "Pune to Mumbai Airport drop taxi service provides reliable transportation for passengers traveling from Pune to Mumbai airport. Travelers can book Ertiga, sedan, or Innova vehicles for comfortable airport drop services. Professional drivers ensure timely pickups from Pune homes, offices, and hotels, ensuring passengers reach the airport on time."
},
{
name: "Mumbai to Pune Ertiga Hire",
description: "Mumbai to Pune Ertiga hire service offers spacious SUV travel for long-distance journeys. The Ertiga is ideal for group travel with comfortable seating and efficient mileage. Professional drivers provide safe expressway travel and punctual pickup services from Mumbai locations."
},
{
name: "Mumbai Airport Taxi Fare",
description: "Mumbai airport taxi fare service provides transparent pricing for passengers booking taxis from the airport to Pune and other destinations. Travelers can choose vehicles such as sedan, Ertiga, or Innova depending on comfort and budget preferences."
},
{
name: "Airport Prepaid Taxi Mumbai",
description: "Airport prepaid taxi Mumbai service offers secure and fixed-price taxi booking from airport terminals. Travelers can book taxis for Pune and nearby destinations with clear fare details and reliable service."
},
{
name: "Mumbai Airport to Outstation Taxi Service",
description: "Mumbai airport to outstation taxi service provides long-distance transportation to cities such as Pune, Nashik, and Lonavala. Travelers can book comfortable vehicles with experienced drivers for safe and smooth travel."
},
{
name: "Mumbai Airport to Pune Ertiga Cab",
description: "Mumbai Airport to Pune Ertiga cab service offers reliable airport transfer with spacious 7-seater vehicles. Travelers can enjoy comfortable seating, luggage space, and smooth expressway travel with professional drivers ensuring safe journeys."
},
{
name: "Mumbai Airport to Pune Ertiga Taxi",
description: "Mumbai Airport to Pune Ertiga taxi service provides convenient and affordable travel between the airport and Pune. Comfortable vehicles and experienced drivers ensure smooth long-distance journeys."
},
{
name: "Ertiga Cab Mumbai Airport to Pune",
description: "Ertiga cab Mumbai Airport to Pune offers spacious SUV travel for passengers seeking comfort and affordability. Professional drivers provide punctual airport pickups and safe expressway travel."
},
{
name: "Book Ertiga from Mumbai Airport to Pune",
description: "Book Ertiga from Mumbai Airport to Pune easily through online platforms with instant confirmation and transparent pricing. Travelers can schedule rides according to flight arrival time."
},
{
name: "Mumbai Airport to Pune Ertiga Rental",
description: "Mumbai Airport to Pune Ertiga rental provides flexible travel options for passengers needing comfortable SUV vehicles for long-distance journeys."
},
{
name: "Ertiga Taxi Mumbai Airport to Pune Price",
description: "Ertiga taxi Mumbai Airport to Pune price offers clear and competitive fare details for passengers planning intercity travel with budget-friendly SUV options."
},
{
name: "Mumbai Airport to Pune Ertiga Car Hire",
description: "Mumbai Airport to Pune Ertiga car hire service provides comfortable and spacious transportation for families and small groups traveling between the airport and Pune."
},
{
name: "Ertiga Cab Service Mumbai Airport to Pune",
description: "Ertiga cab service Mumbai Airport to Pune offers dependable long-distance travel with experienced drivers and comfortable vehicles ensuring safe journeys."
},
{
name: "Mumbai Airport to Pune 6 Seater Ertiga Cab",
description: "Mumbai Airport to Pune 6 seater Ertiga cab service offers spacious travel for small groups with comfortable seating and smooth highway performance ensuring a relaxed journey."
}
],

tableData: [
["Mumbai Airport to Pune Ertiga on Rent","Mumbai to Pune Ertiga Cab"],
["Navi Mumbai to Pune Ertiga Cab","Dadar to Pune Ertiga Cab Booking"],
["One Way Ertiga Cab Booking","7 Seater Car Rental Mumbai Airport"],
["6 Seater Car Rental Mumbai Airport","Pune to Mumbai Airport Drop Taxi Service"],
["Mumbai to Pune Ertiga Hire","Mumbai Airport Taxi Fare"],
["Airport Prepaid Taxi Mumbai","Mumbai Airport to Outstation Taxi Service"],
["Mumbai Airport to Pune Ertiga Cab","Mumbai Airport to Pune Ertiga Taxi"],
["Ertiga Cab Mumbai Airport to Pune","Book Ertiga from Mumbai Airport to Pune"],
["Mumbai Airport to Pune Ertiga Rental","Ertiga Taxi Mumbai Airport to Pune Price"],
["Mumbai Airport to Pune Ertiga Car Hire","Ertiga Cab Service Mumbai Airport to Pune"],
["Mumbai Airport to Pune 6 Seater Ertiga Cab","Mumbai Airport to Pune Ertiga Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Ertiga for Airport Travel",
    WhyChoosedescription: "Velocity Cabs offers spacious and comfortable Ertiga cabs for Mumbai Airport to Pune travel, ideal for families and small groups with ample seating and luggage space."
  },
  {
    WhyChooseheading: "Experienced Airport Transfer Drivers",
    WhyChoosedescription: "Our drivers are experienced in handling Mumbai Airport pickups and Pune drop routes via the Mumbai Pune Expressway, ensuring timely pickup and smooth travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent pricing for Mumbai Airport to Pune Ertiga cab bookings. Customers receive clear fare details including toll charges, parking fees, and driver allowance."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Mumbai Airport to Pune Ertiga cab service operates 24/7. Whether your flight arrives early morning or late night, Velocity Cabs ensures reliable airport transfers anytime."
  },
  {
    WhyChooseheading: "Clean & Sanitized AC Vehicles",
    WhyChoosedescription: "All Ertiga vehicles are fully air-conditioned, well maintained, and regularly sanitized to provide a safe and comfortable airport travel experience."
  },
  {
    WhyChooseheading: "Direct Pickup from Airport Terminals",
    WhyChoosedescription: "We provide direct pickup from Mumbai Airport Terminal 1 and Terminal 2 with drivers waiting at designated pickup points for hassle-free travel."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible booking options including one-way airport drop, round-trip travel, and customized travel plans from Mumbai Airport to Pune."
  },
  {
    WhyChooseheading: "Trusted Airport Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai Airport to Pune Ertiga cab bookings thanks to punctual drivers, comfortable vehicles, and professional airport transfer service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai Airport to Pune Ertiga cab service?", answer: "Yes, Velocity Cabs provides comfortable Ertiga cab services from Mumbai Airport to Pune." },
  { question: "Which Mumbai Airport terminals do you provide pickup from?", answer: "Velocity Cabs provides pickup from both Terminal 1 and Terminal 2 of Mumbai Airport." },
  { question: "How far is Mumbai Airport from Pune?", answer: "The road distance between Mumbai Airport and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Ertiga cab available 24 hours from Mumbai Airport?", answer: "Yes, our Ertiga cab service operates 24/7 for airport transfers." },
  { question: "How many passengers can travel in Ertiga?", answer: "Ertiga can comfortably accommodate 5 to 6 passengers along with luggage." },
  { question: "Can I book a one-way Ertiga cab?", answer: "Yes, we provide both one-way and round-trip Ertiga cab services from Mumbai Airport to Pune." },
  { question: "Are Ertiga vehicles air-conditioned?", answer: "Yes, all Ertiga vehicles are fully air-conditioned and well maintained." },
  { question: "Can I book the Ertiga cab online?", answer: "Yes, customers can easily book Mumbai Airport to Pune Ertiga cab services online or through phone booking." },
  { question: "Do drivers wait at the airport for pickup?", answer: "Yes, our drivers wait at the airport arrival pickup area to ensure smooth passenger pickup." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Deshmukh",
    feedback:
      "Spacious Ertiga made the Mumbai Airport to Pune journey very comfortable. The ride was smooth, luggage space was sufficient, and the long travel felt easy and relaxed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "Traveling in an Ertiga from Mumbai Airport to Pune was a very pleasant experience. The vehicle was clean, comfortable for family travel, and the journey was well-managed throughout.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Ertiga Cab | Velocity Cabs",
  "description": "Book Mumbai Airport to Pune Ertiga cab with Velocity Cabs. One-way, round trip & airport drop services available. 6/7 seater Ertiga for comfortable travel from Mumbai Airport to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1380"
  }
};





  return (
    <div>
      <Helmet>
  <title>Mumbai Airport to Pune Ertiga Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book Mumbai Airport to Pune Ertiga cab with Velocity Cabs. 6/7 seater Ertiga for airport pickups, one-way trips, round trips & outstation travel. Reliable and safe taxi service."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/58.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttopunertigacab;